import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { cadastroClientes } from '@constants/URL'

class APIClientsComunication extends APITemplate {
  /**
   * Enviar comunicado para o cliente, com link para cadastro na plataforma sem serviço relacionado.
   * @param id_cliente
   * @param id_cadastro_cliente
   * @param assunto_email
   * @param texto_email
   * @param from
   * @param enviar_imagem
   * @param enviar_copia
   * @param enviar_anexo
   * @param email_cco
   * @param email_cc
   * @param receber_copia
   * @param enviar_assinatura_email
   * @returns {Promise<void>}
   */
  async sendComunicate({
    id_cliente,
    hasIdCadastroCliente,
    assunto_email,
    texto_email,
    _from,
    enviar_imagem,
    enviar_copia,
    enviar_anexo,
    email_cco,
    email_cc,
    receber_copia,
    enviar_assinatura_email,
  }) {
      const data = {
          id_cliente: id_cliente, // Number or Array
          assunto_email: assunto_email,
          texto_email: texto_email,
          from: _from,
          enviar_imagem: enviar_imagem,
          enviar_copia: enviar_copia,
          enviar_anexo: enviar_anexo,
          email_cco: email_cco || '',
          email_cc: email_cc || '',
          receber_copia: receber_copia,
          enviar_assinatura_email: enviar_assinatura_email,
      }

      const url = hasIdCadastroCliente ? cadastroClientes.send_announcement : cadastroClientes.send_announcement_client

      const r = await con.post(url, data)

      // `r || {}` devolvia uma resposta SEM `status`, e o modal de envio tratava
      // isso como "nada a dizer": o assessor não recebia feedback nenhum quando
      // a requisição morria. Fallback com status e próxima ação [review-lote].
      return (
          r ||
          this.buildErrorResponse({
              message: 'Não foi possível enviar o comunicado. Tente novamente mais tarde ou contate o suporte.',
              value: null,
          })
      )
  }
}

const apiClientsComunication = new APIClientsComunication()
export { apiClientsComunication }
